import React from 'react'
import TableHeadRowCenter from '../../components/TableComponents/TableHeadRowCenter'
import TableBodyRowCenter from '../../components/TableComponents/TableBodyRowCenter'
import { Button } from 'react-bootstrap'
import TableHeadRowStart from '../../components/TableComponents/TableHeadRowStart'
import TableBodyRowStart from '../../components/TableComponents/TableBodyRowStart'
import { formatMoney } from '../../utilities/formatMoneyValue'
import { format, addHours } from 'date-fns'

const TableData = ({ array, editFunction, deleteFunction }) => {
  return (
    <>
      <thead>
        <tr>
          {/* <TableHeadRowCenter text='Código' /> */}
          <TableHeadRowStart text='Data de pagamento' />
          <TableHeadRowStart text='Doutor' />
          <TableHeadRowStart text='Paciente' />
          <TableHeadRowStart text='Observação' />
          {/* <TableHeadRowStart text='Tipo de atendimento' /> */}
          <TableHeadRowStart text='Forma de pagamento' />
          <TableHeadRowCenter text='Valor' />
          <TableHeadRowCenter text='Ações' />
        </tr>
      </thead>

      <tbody >
        {array?.map((cliente, index) => {
          const nome = cliente.tecnico.nome.split(' ')[0]
          return (
            <tr key={cliente.codigo} className='trBody'>
              <TableBodyRowStart text={format(addHours(new Date(cliente.data_pagamento), 3), 'dd/MM/yyyy')} />
              <TableBodyRowStart text={nome} />
              <TableBodyRowStart text={cliente.paciente.nome} />
              {/* <TableBodyRowStart text={cliente.tipo_atendimento} /> */}
              <TableBodyRowStart text={cliente.observacao} />
              <TableBodyRowStart text={cliente.forma_pagamento.replace('_', ' ')} />
              <TableBodyRowCenter text={formatMoney(cliente.valor_total)} />

              <td className='tableRowCenter'>
                <div className='buttonContainer'>
                  <Button variant='outline-secondary' className='m-0 p-0 px-2' onClick={() => editFunction(cliente.id)} >Editar</Button>
                  <Button variant='outline-danger' className='m-0 p-0 px-2' onClick={() => { deleteFunction(cliente.id) }} >Remover</Button>
                </div>
              </td>
            </tr>
          )
        })}
      </tbody >
    </>
  )
}

export default TableData